<template>
    <div>
        <el-table :data="tableData"  border style="width: 100%">
            <el-table-column type="index" width="50"></el-table-column>
            <el-table-column align="center" label='处置方法名称' width="auto">
                <template slot-scope="scope">
                    <el-input size="small" v-model="scope.row.checkedName" @change="changeCheckedName($event,scope.$index)"
                              placeholder="请输入内容"></el-input>
                </template>
            </el-table-column>
            <el-table-column align="center" label='价格' width="auto">
                <template slot-scope="scope">
                    <el-input size="small" v-model="scope.row.checkedCost" @change="changeCheckedCost($event,scope.$index)"
                              placeholder="请输入内容"></el-input>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="120">
                <template slot-scope="scope">
                    <el-button @click.native.prevent="deleteRow(scope.$index, tableData)" type="text" size="small">移除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="add">
            <el-autocomplete style="width:100%;" v-model="approach" :fetch-suggestions="querySearch" placeholder="请选择处置方法"
                             @select="handleSelect"></el-autocomplete>
        </div>

        <div class="inOne-TabBttom">
            <el-button v-if='exhibition' @click="futureSave()" type="warning"><i class="fa fa-floppy-o"></i>提交订单</el-button>
            <el-button v-else @click="handleSubmit()" type="primary"><i class="fa fa-floppy-o"></i>提交订单</el-button>
            <el-button @click="handleReset()" type="danger"><i class="fa fa-pencil" aria-hidden="true"></i>重置
            </el-button>
        </div>
    </div>
</template>

<script>
  export default {
    data() {
      return {
        // repetitionId:0,       // 第二次提交保存id
        uData:null,           // 用户数据对象
        exhibition:false,     // 数据展示
        approach: '',
        tableData: [
          // {
          //     "checkedName":'针灸',
          //     'checkedCost':100
          // }
        ],
        restaurants: [
          {"value": '针灸', "address": 100},
          {"value": '血糖仪', "address": 5},
          {"value": '艾灸', "address": 600},
          {"value": '中药敷贴', "address": 0},
          {"value": '中药面膜', "address": 0},
          {"value": '烧烫伤', "address": 0},
          {"value": '小儿惊吓推拿', "address": 0},
          {"value": '成人惊吓推拿', "address": 0},
          {"value": '惊吓针刺', "address": 0},
          {"value": '正骨', "address": 0},
          {"value": '重症诊疗', "address": 950},
          {"value": '儿童推拿', "address": 0},
          {"value": '自定义处置方法', "address": 0},
        ],
      }
    },
    methods: {
      futureSave(){       // 黄色提交
        let that = this;
        if(that.tableData.length == 0){
          that.$message({
            message: '请至少选择一个处置方法',
            type: 'warning'
          });
          return;
        }
        for(let i=0;i<that.tableData.length;i++){
          let price = that.tableData[i].checkedCost;
          if(price <= 0){
            this.$notify({
              title: '提示',
              message: '请检查并输入价格',
              type: 'warning'
            });
            return;
          }
        }
        that.$confirm("您已经提交订单，是否再次提交？", "提示", {}).then(() => {
          that.$axios({
            url: "/api/inquiry/otherCheck/" + that.uData.reservationId,
            method: "POST",
            data: that.tableData
          }).then(res => {
            console.log(res);
            if (res.data.code == 200) {
              that.$message({
                type: 'success',
                message: '保存成功'
              });
            } else {
              that.$message({
                type: 'error',
                message: '保存失败'
              });
            }
          }).catch(err => {
            console.log(err);
          });
        }).catch(() => {
          that.$message({
            type: "info",
            message: "已取消保存"
          });
        });
      },
      handleReset() {
        this.tableData = [];
      },
      handleSubmit() {        // 蓝色提交
        let that = this;
        if(that.tableData.length == 0){
          that.$message({
            message: '请至少选择一个处置方法',
            type: 'warning'
          });
          return;
        }
        for(let i=0;i<that.tableData.length;i++){
          let price = that.tableData[i].checkedCost;
          if(price <= 0){
            this.$notify({
              title: '提示',
              message: '请检查并输入价格',
              type: 'warning'
            });
            return;
          }
        }
        that.$confirm("确认保存吗？", "提示", {}).then(() => {
          that.$axios({
            url: "/api/inquiry/otherCheck/" + that.uData.reservationId,
            method: "POST",
            data: that.tableData
          }).then(res => {
            console.log(res);
            if (res.data.code == 200) {
              that.$message({
                type: 'success',
                message: '保存成功'
              });
            } else {
              that.$message({
                type: 'error',
                message: '保存失败'
              });
            }
          }).catch(err => {
            console.log(err);
          });
        }).catch(() => {
          that.$message({
            type: "info",
            message: "已取消保存"
          });
        });
      },
      querySearch(queryString, cb) {
        var restaurants = this.restaurants;
        var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
        cb(results);
      },
      createFilter(queryString) {
        return (restaurant) => {
          return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
      handleSelect(item) {
        let postData = {
          "checkedName": item.value,
          'checkedCost': item.address
        };
        this.approach = '';
        this.tableData.push(postData);
      },
      changeCheckedCost(val, index) {      //  修改当前点击行 处置方法的金额
        this.tableData[index].checkedCost = val;
      },
      changeCheckedName(val, index) {      //  修改当前点击行 处置方法的名字
        this.tableData[index].checkedName = val;
      },
      deleteRow(index, rows) {              // 单行 移除
        rows.splice(index, 1);
      },
      getData(o){
        let that = this;
        that.uData = o;
        if(o.assist == null){
          that.exhibition = false;
        }else{
          that.exhibition = true;
          for(let i=0;i<o.assist.length;i++){
            that.tableData.push({
              "checkedName":o.assist[i].checkedName,
              'checkedCost':o.assist[i].checkedCost
            });
          }
        }
      }
    }
  }
</script>

<style scoped>
    .el-button--primary {
        color: #fff;
        background-color:  rgb(60, 110, 169);
        border-color: rgb(60, 110, 169);
    }
    .el-button--primary.is-disabled, .el-button--primary.is-disabled:active, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover {
        color: #fff;
        background-color: rgba(60, 110, 169, 0.65);
        border-color: rgba(60, 110, 169, 0.65);
    }
    .el-button--primary:focus, .el-button--primary:hover {
        background: rgba(60, 110, 169, 0.65);
        border-color: rgba(60, 110, 169, 0.65);
        color: #fff;
    }
    .inOne-TabBttom {
        margin-top: 20px;
        text-align: center;
    }

    .add {
        width: 100%;
        margin-top: 10px;
        margin-bottom: 20px;
    }
</style>



// WEBPACK FOOTER //
// inquiryExamine.vue?c71035da